var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Box, Center, Text } from '@chakra-ui/react';
import { action, makeObservable, observable } from 'mobx';
import { observer } from 'mobx-react';
import React from 'react';
import { Loading } from '../components/Loading';
import { AppColor } from '../const/AppDefaults';
export class ProgressBarState {
    constructor() {
        this.progess = 0;
        this.progessMessage = "";
        this.color = "green";
        makeObservable(this);
    }
    setProgress(pr) {
        this.progess = pr;
    }
    setProgressMessage(msg) {
        this.progessMessage = msg;
    }
    setColor(color) {
        this.color = color;
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], ProgressBarState.prototype, "progess", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ProgressBarState.prototype, "progessMessage", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ProgressBarState.prototype, "color", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], ProgressBarState.prototype, "setProgress", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], ProgressBarState.prototype, "setProgressMessage", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], ProgressBarState.prototype, "setColor", null);
let ProgressBar = class ProgressBar extends React.Component {
    constructor(prop) {
        super(prop);
    }
    render() {
        return (React.createElement(Box, { w: '100%' },
            this.props.state.progess < 100 && React.createElement(Loading, null),
            React.createElement(Center, { mt: '15px' },
                React.createElement(Text, { color: AppColor.GreetingMessage }, this.props.state.progessMessage))));
    }
};
ProgressBar = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], ProgressBar);
export { ProgressBar };
